import { ExternalLoginComponent } from '@auth/external-login/external-login.component';
import { AuthGuard } from './guards/auth-guard.service';
import { HomePageComponent } from './home-content/home/home-page/home-page.component';
import { AgentComponent } from './registration/agent/agent.component';
import { UserComponent } from './registration/user/user.component';
import { UserSignupComponent } from './registration/usersignup/usersignup.component';
import { FareRulesComponent } from './ytb-modules/flight/fare-rules/fare-rules.component';
import { GlobalErrorPageComponent } from './ytb-modules/global-error/global-error-page.component';
import { PaymentsComponent } from './ytb-modules/payments/payment.component';
import { SiteMaintainanceComponent } from './SiteMaintainance/SiteMaintainance.component';
import { EmailUnSubscribeComponent } from './EmailUnSubscribe/emailUnSubscribe.component';
import { MakeExternalPaymentsComponent } from './MakeExternalPayment/makeExternalPayment.component';
import { IssueTicketComponent } from './IssueTicket/issueTicket.component';
import { EmailConfirmationCheckComponent } from './EmailConfirmationCheck/emailConfirmationCheck.component';
import { Routes } from '@angular/router';

export const mainAppRoutes: Routes = [
  { path: '', pathMatch: 'full', component: HomePageComponent },
  {
    path: 'Email-Confirmation-Check',
    component: EmailConfirmationCheckComponent,
    data: {
      title: 'Email Confirmation Check - Your Travel Booking',
      description: 'Validating your Email Address At Yourtravelbooking.Com',
      image:''
    },
  },
  {
    path: 'issueTicket',
    component: IssueTicketComponent,
    data: {
      title: 'Issue ticket - Your Travel Booking',
      description: 'Updating ticket status At Yourtravelbooking.Com',
      image:''
    },
  },
  {
    path: 'makeExternalPayment',
    component: MakeExternalPaymentsComponent,
    data: {
      title: 'Make Payment for Booking Additional Support - Your Travel Booking',
      description: 'Make Payment for Booking Additional Support - Your Travel Booking',
      image:''
    },
  },
  {
    path: 'unsubscribe',
    component: EmailUnSubscribeComponent,
    data: {
      title: 'Unsubscribe Notifications - Your Travel Booking',
      description: 'Un subscribing to Notifications At Yourtravelbooking.Com',
      image:''
    },
  },
  {
    path: 'sitemaintainance',
    component: SiteMaintainanceComponent,
    data: { title: 'Your Travel Booking-Site ${Maintainance}',
      image:'',
      description:'' },
  },

  {
    path: 'payments',
    component: PaymentsComponent,
    data: { title: 'Your Travel Booking-Payments',
      image:'',
      description:'' },
  },

  {
    path: 'login',
    component: ExternalLoginComponent,
    data: { title: 'YTB Login',
      image:'',
      description:''}
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./registration/registration.module').then(
        (m) => m.RegistrationModule
      ),
    data: {
      title: 'Sign Up - Your Travel Booking',
      description: 'Sign Up For Yourtravelbooking.Com And Get Best Deals On Hotels, Flight Tickets, Cars And Activities Online',
      image:''
    }
  },
  {
    path: 'SigninUser',
    component: UserComponent,
    data: { title: 'Sign In - Your Travel Booking',
      description:"Welcome to Your Travel Booking Website! For your security, you will always be asked to log in to your YTB account.",
      image:''
    }
  },
  {
    path: 'SignupAgent',
    component: AgentComponent,
    data: { title: 'Sign Up - Your Travel Booking',
      description: 'Sign Up For Yourtravelbooking.Com And Get Best Deals On Flight Tickets Online',
      image:''}
  },
  {
    path: 'SignupUser',
    component: UserSignupComponent,
    data: { title: 'Sign Up - Your Travel Booking',
      description: 'Sign Up For Yourtravelbooking.Com And Get Best Deals On Flight Tickets Online',
      image:''}
  },
  {
    path: 'fare-rules',
    component: FareRulesComponent,
    data: { title: 'Your Travel Booking- Fare Rules',
      image:'',
      description:'' },
  },
  {
    path: 'help',
    loadChildren: () =>
      import('./help-center/general-enquiry/general-enquiry.module').then(
        (m) => m.GeneralEnquiryModule
      ),
    data: { title: 'Your Travel Booking- Help', image: '/assets/images/whatsapp-images/YTBHLP.png' },
  },
  {
    path: 'contactus',
    loadChildren: () =>
      import('./help-center/contactus/contactus.module').then(
        (m) => m.ContactusModule
      ),
    data: { title: 'Your Travel Booking- Contact Us', image: '/assets/images/whatsapp-images/YTBCNTUS.png' },
  },
  {
    path: 'chatwithus',
    loadChildren: () =>
      import('./help-center/chatus/chatus.module').then((m) => m.ChatusModule),
    data: { title: 'Your Travel Booking- Chat Us', image: '/assets/images/whatsapp-images/YTBCHAT.png' },
  },
  {
    path: 'socialmedia',
    loadChildren: () =>
      import('./help-center/socialnetworking/socialnetworking.module').then(
        (m) => m.SocialnetworkingModule
      ),
    data: { title: 'Your Travel Booking- Social Networking', image: '/assets/images/whatsapp-images/YTBSCLNTW.png' },
  },

  {
    path: 'coupons',
    loadChildren: () =>
      import('./coupons/coupons.module').then(m => m.CouponsModule),
    data: {
      title: 'All Coupons Information - Your Travel Booking',
      description: 'All Coupons Information at YourTravelBooking'
    },
  },

  
  {
    path: 'home/:tab',
    loadChildren: () =>
      import('./ytb-modules/flight/flight-search-input/flight-search-input.module').then(m => m.FlightSearchInputModule),
    data: {
      title: 'Online Flight Tickets Booking at Lowest Airfare – YourTravelBooking',
      description: 'Book Online Flight Tickets at Lowest Airfare with Yourtravelbooking. Here you can find the cheapest airfares, compare prices and book your flight tickets online with us to save money.',
    },
  },
  {
    path: 'home/:tab',
    component: HomePageComponent,
    data: {
      title: 'Book Hotels - Deals and Discounts Online | YourTravelBooking',
      description: 'Book hotels online at best price from yourtravelbooking.com. Find amazing offers and deals on hotel bookings – Lowest price guarantee. Book now!'
    },
  },
  {
    path: 'search',
    loadChildren: () =>
      import('./ytb-modules/flight/flight-search/flight-search.module').then(
        (m) => m.FlightSearchModule
      ),
    data: {
      title: '${from} To ${to} Flight Results | YourTravelBooking',
      navigateurl: 'home/flight',
    },
  },
  {
    path: 'flight-details',
    loadChildren: () =>
      import('./ytb-modules/flight/selected-flights-cart/selected-flights-cart.module').then(
        (m) => m.SelectedFlightsCartModule
      ),
    data: {
      title: '${detailsText} | YourTravelBooking',
      navigateurl: 'home/flight',
    },
  },
  {
    path: 'book',
    loadChildren: () =>
      import('./ytb-modules/flight/book-flight/book-flight.module').then(
        (m) => m.BookFlightModule
      ),
    data: {
      title: 'Flight Details | Passenger Information | YourTravelBooking',
      navigateurl: 'home/flight',
    },
  },
  {
    path: 'voucher',
    loadChildren: () =>
      import(
        './ytb-modules/flight/booking-voucher/booking-voucher.module'
      ).then((m) => m.BookingVoucherModule),
    data: { title: 'Flight Booking Successful | YourTravelBooking' },
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./ytb-modules/flight/flight-payment/flight-payment.module').then(
        (m) => m.FlightPaymentModule
      ),
    data: {
      title: 'Flight Payment - Your Travel Booking',
      navigateurl: 'home/flight',
    },
  },
  {
    path: 'my-account',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./profile/myaccount/myaccount.module').then(
        (p) => p.MyaccountModule
      ),
    data: {
      title: 'Your Travel Booking- View Profile',
      description: 'Your Travel Booking Provides Customers Best Deals On Hotels, Flight Tickets, Cars And Activities Online',
      image: '/assets/images/whatsapp-images/YTBAU.png'
    },
  },
 
  {
    path: 'createbranch',
    loadChildren: () =>
      import('./profile/createBranch/create-branch.module').then(
        (p) => p.CreateBranchModule
      ),
    data: {
      title: 'Create your branch View Profile',
      description: 'Your Travel Booking Provides feasibility to Create branch for your organization',
      image: '/assets/images/whatsapp-images/YTBAU.png'
    },
  },
  {
    path: 'createorganizationuser',
    loadChildren: () =>
      import('./profile/createOrganizationUser/create-organization-user.module').then(
        (p) => p.CreateOrganizationUserModule
      ),
    data: {
      title: 'Create User for your Organization View Profile',
      description: 'Your Travel Booking Provides feasibility to Create User for your Organization',
      image: '/assets/images/whatsapp-images/YTBAU.png'
    },
  },
  {
    path: 'manageorganization',
    loadChildren: () =>
      import('./profile/manageOrganizations/manage-oraganization.module').then(
        (p) => p.ManageOrganizationModule
      ),
    data: {
      title: 'Manage your Organization View Profile',
      description: 'Your Travel Booking Provides feasibility to Manage your Organization',
      image: '/assets/images/whatsapp-images/YTBAU.png'
    },
  },
  {
    path: 'about-us',
    loadChildren: () =>
      import('./aboutus/aboutus.module').then((p) => p.AboutusModule),
    data: {
      title: 'About Your Travel Booking',
      description: 'Your Travel Booking Provides Customers Best Deals On Hotels, Flight Tickets, Cars And Activities Online',
      image: 'https://www.yourtravelbooking.com/assets/images/whatsapp-images/YTBAU.png'
    },
  },
  {
    path: 'cancellation',
    loadChildren: () =>
      import('./cancellation/cancellation.module').then(
        (p) => p.CancellationModule
      ),
    data: {
      title: 'Cancellation Policy - Your Travel Booking',
      description: 'Your Travel Booking Cancellation Policy Are Subject To Cancellation Penalty Levied By The Airlines',
      image: '/assets/images/whatsapp-images/YTBCNL.png'
    },
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./privacypolicy/privacypolicy.module').then(
        (p) => p.PrivacypolicyModule
      ),
    data: {
      title: 'Privacy Policy - Your Travel Booking',
      description: 'Your Travel Booking Is Committed To Ensuring That We Keep The Information That You Share With Us When You Use This Website As Securely As Possible.',
      image: 'https://www.yourtravelbooking.com/assets/images/whatsapp-images/YTBPP.png'
    },
  },
  {
    path: 'covid-policy',
    loadChildren: () =>
      import('./covidpolicy/covidpolicy.module').then(
        (p) => p.CovidpolicyModule
      ),
    data: {
      title: 'Covid Policy - Your Travel Booking',
      description: 'Your Travel Booking Is Committed To Ensuring That We Keep The Information That You Share With Us When You Use This Website As Securely As Possible.',
      image: 'https://www.yourtravelbooking.com/assets/images/whatsapp-images/YTBCP.png'
    },
  },
  {
    path: 'refund-policy',
    loadChildren: () =>
      import('./refund/refund.module').then((p) => p.RefundModule),
    data: {
      title: 'Refunds - Your Travel Booking',
      description: 'Your Travel Booking Cancellation Charges Will Be Deducted From The Refund Amount, Before The Refund Is Made',
      image: 'https://www.yourtravelbooking.com/assets/images/whatsapp-images/YTBRFD.png'
    },
  },
  {
    path: 'cookiepolicy',
    loadChildren: () =>
      import('./cookiepolicy/cookiepolicy.module').then((p) => p.CookiePolicyModule),
    data: {
      title: 'Cookie Policy - Your Travel Booking',
      description: 'Your Travel Booking Cookie Policy',
      image: 'https://www.yourtravelbooking.com/assets/images/whatsapp-images/YTBRFD.png'
    },
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () =>
      import('./termsandconditions/termsandconditions.module').then(
        (p) => p.TermsandconditionsModule
      ),
    data: {
      title: 'Terms And Conditions- Your Travel Booking',
      description: 'Your Travel Booking Website Outlines The Terms And Conditions Under Which We Provide Our Online Service To You',
      image: 'https://www.yourtravelbooking.com/assets/images/whatsapp-images/YTBTC.png'
    },
  },
  {
    path: 'our-services',
    loadChildren: () =>
      import('./ourservices/ourservices.module').then(
        (p) => p.OurservicesModule
      ),
    data: {
      title: 'Services - Your Travel Booking',
      description: 'Your Travel Booking Offers Best Deals On Hotels, Flight Tickets, Car Services Online At Lowest Price. Book Now!',
      image: 'https://www.yourtravelbooking.com/assets/images/whatsapp-images/YTBSRC.png'
    },
  },
  {
    path: 'feedback',
    loadChildren: () =>
      import('./help-center/feedback/feedback.module').then((p) => p.FeedbackModule),
    data: {
      title: 'Services, Reviews and Experience - Your Travel Booking',
      description: 'Your Travel Booking Feedback Lets Customers Signin And Rate Their Overall Experiences Of Hotel Stay, Flight Bookings And Car Booking Online',
      image: 'https://www.yourtravelbooking.com/assets/images/whatsapp-images/YTBFDB.png'
    },
  },
  {
    path: 'change-password',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./changepassword/changepassword.module').then(
        (m) => m.ChangepasswordModule
      ),
    data: {
      title: 'Change Password - Your Travel Booking',
      description: 'We can update your account password with new password to make use of Profile services',
      image: 'https://www.yourtravelbooking.com/assets/ytb-images/yourtravelbooking-logo.png'
    },
  },
  {
    path: 'print-itinerary',
    loadChildren: () =>
      import('./help-center/printitinery/printitinery.module').then(
        (m) => m.PrintitineryModule
      ),
    data: {
      title: 'Print Itinerary - Your Travel Booking',
      description: 'Enter Your Booking Number And Print The Itinerary At Yourtravelbooking.Com'
    },
  },
  {
    path: 'flight-service',
    loadChildren: () =>
      import('./help-center/flightservice/flightservice.module').then(
        (m) => m.FlightserviceModule
      ),
    data: {
      title: 'Your Travel Booking - Flight Service',
      image: '/assets/images/whatsapp-images/YTBFTSRC.png'
    },
  },

  {
    path: 'pending-voucher',
    loadChildren: () =>
      import(
        './ytb-modules/flight/partial-booking-confirmation/partial-booking-confirmation.module'
      ).then((m) => m.PartialBookingConfirmationModule),
    data: {
      title: 'Flight Booking Pending | YourTravelBooking'
    }
  },
  {
    path: 'reschedule/:pnr',
    loadChildren: () =>
      import(
        './ytb-modules/flight/flightshedulechange/flightshedulechange.module'
      ).then((m) => m.FlightshedulechangeModule),
    data: { title: 'Your flight shcedule has been changed' },
  },
  {
    path: 'post-ancillary',
    loadChildren: () =>
      import(
        './ytb-modules/flight/post-ancillary-purchases/post-ancillary-purchases.module'
      ).then((m) => m.PostAncillaryPurchasesModule),
  },
  {
    path: 'post-voucher',
    loadChildren: () =>
      import(
        './ytb-modules/flight/post-voucher-confirmation/post-voucher-confirmation.module'
      ).then((m) => m.PostVoucherConfirmationModule),
    data: { title: ' Flight booking ${confirmation} - Flight Voucher' },
  },
  {
    path: 'lp/flights/:destcode',
    loadChildren: () =>
      import(
        './ytb-modules/flight/flight-landing/flight-landing.module'
      ).then((m) => m.FlightLandingModule),
    data: { title: 'Flights from ${from} to ${to}' }
  },
  {
    path: 'paypalPayment',
    loadChildren: () =>
      import(
        './ytb-modules/paypal-success/paypal-success.module'
      ).then((m) => m.PaypalSuccessModule)
  },
  {
    path: 'error',
    component: GlobalErrorPageComponent,
    data: {
      title: 'Your Travel Booking- Contact Us for support on your booking',
      image: '/assets/images/whatsapp-images/YTBFTSRC.png'
    },
  },
  {
    path: 'couponsDownload/:couponCode',
    loadChildren: () => import('./couponDownloads/coupon-download.module').then(m => m.CouponsDownloadModule),
    data: {
      title: '${module}',
      image: '/assets/images/whatsapp-images/YTBFTSRC.png'
    }
  },
  {
    path: 'corporatetravelplanning',
    loadChildren: () =>
      import('./ourservices/content/corporatetravelplanning/corporatetravelplanning.module').then((p) => p.CorporateTravelPlanningModule),
      data: {
        title: '${corporatetravelplanning} - Your Travel Booking',
        description: 'Your Travel Booking Offers Best Deals On Hotels, Flight Tickets, Car Services Online At Lowest Price. Book Now!',
        image: '/assets/images/whatsapp-images/YTBSRC.png'
      },
  },
  
  {
    path: 'worldwideairticketing',
    loadChildren: () =>
      import('./ourservices/content/worldwideairticketing/worldwideairticketing.module').then((p) => p.WorldWideAirTicketingComponentModule),
      data: {
        title: '${worldwideairticketing} - Your Travel Booking',
        description: 'Your Travel Booking Offers Best Deals On Hotels, Flight Tickets, Car Services Online At Lowest Price. Book Now!',
        image: '/assets/images/whatsapp-images/YTBSRC.png'
      },
  },

  {
    path: 'createorganization',
    loadChildren: () =>
      import('./ourservices/content/worldwideairticketing/worldwideairticketing.module').then((p) => p.WorldWideAirTicketingComponentModule),
      data: {
        title: '${worldwideairticketing} - Your Travel Booking',
        description: 'Your Travel Booking Offers Best Deals On Hotels, Flight Tickets, Car Services Online At Lowest Price. Book Now!',
        image: '/assets/images/whatsapp-images/YTBSRC.png'
      },
  },
  
  {
    path: '**',
    redirectTo: '',
  },
  // {
  //   path: 'createorganization',
  //   loadChildren: () =>
  //     import('./profile/createOrganization/create-organization.module').then(
  //       (p) => p.CreateOrganizationModule
  //     ),
  //   data: {
  //     title: 'Create your Organization View Profile',
  //     description: 'Your Travel Booking Provides feasibility to Create Organization',
  //     image: '/assets/images/whatsapp-images/YTBAU.png'
  //   },
  // },



];